import React from 'react';
import styles from './Boton.module.css';
import * as Imagenes from '../Iconos.js';

const BotonInsertar = (props) => {
  const estilo = props.estilo;
  const estiloImagen = props.estiloImagen;
  const onClick = props.onClick;

  return (
    <button
      className={`${styles.botonTransparente} ${styles.botonInsertar} ${estilo}`}
      onClick={onClick}
    >
      <img
        src={Imagenes.agregar}
        className={`${styles.botonInsertar} ${estiloImagen}`}
        alt="Insertar"
      />
    </button>
  );
};

export default BotonInsertar;
